import React, { useState, useEffect } from 'react';
import { parseEventDetailUrl } from '../utils/encryption';
import EventDetailPage from './EventDetailPage';
import { goHome } from '../utils/navigation';

const EventDetailRoute: React.FC = () => {
  const [eventId, setEventId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const currentPath = window.location.pathname;
    
    try {
      const { id, locationSlug, titleSlug } = parseEventDetailUrl(currentPath);
      
      if (id) {
        setEventId(id);
        setError(null);
        console.log('Event URL parsed:', { id, locationSlug, titleSlug });
      } else {
        setError('Invalid event URL');
      }
    } catch (err) {
      console.error('Error parsing event URL:', err);
      setError('Failed to parse event URL');
    } finally {
      setLoading(false);
    }
  }, []);

  const handleClose = () => {
    goHome();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-red-50 to-pink-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-dpn-pink mx-auto mb-4"></div>
          <p className="font-lucy-rose text-dpn-olive">Loading event...</p>
        </div>
      </div>
    );
  }

  if (error || !eventId) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-orange-50 via-red-50 to-pink-50 flex items-center justify-center">
        <div className="text-center max-w-md mx-auto px-4">
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            <strong className="font-bold">Error!</strong>
            <span className="block sm:inline"> {error || 'Invalid event URL'}</span>
          </div>
          <button
            onClick={handleClose}
            className="bg-dpn-pink text-white px-6 py-2 rounded-lg hover:bg-dpn-raspberry transition-colors duration-200 font-lucy-rose"
          >
            Go Home
          </button>
        </div>
      </div>
    );
  }

  return <EventDetailPage eventId={eventId} onClose={handleClose} />;
};

export default EventDetailRoute;
